import { createContext, Dispatch, SetStateAction } from 'react'
import { To } from 'react-router-dom'

type SidebarContextType = {
  selectedItemRoutePath?: To
  setSelectedItemRoutePath: Dispatch<SetStateAction<SidebarContextType['selectedItemRoutePath']>>
}

export const SidebarContext = createContext<SidebarContextType>({} as SidebarContextType)
